import React, { Component, Fragment } from "react";

const AttributeVsFormParam = (values) => {
  const [attr, formVal] = values;
  return attr !== undefined || attr !== null || attr !== "" ? attr : formVal;
};

const getValidInchVal = (val) => val && val !== "-"; // '-' is to filter out values which have not been entered and the app form is saving '-' instead of empty value

const getFractionInches = (values) => {
  let result = "";
  if (values && Array.isArray(values)) {
    let numbers = values.filter(getValidInchVal);
    if (numbers.length === 1) {
      result = numbers[0];
    } else if (numbers.length === 2) {
      result = (
        <Fragment>
          <span style={{ whiteSpace: "nowrap" }}>
            {numbers[0]} <sup>{numbers[1].split("/")[0]}</sup>⁄<sub>{numbers[1].split("/")[1]}</sub>
          </span>
        </Fragment>
      );
    }
  }
  return result;
};

const MultiRowTitleFormatter = (title_values, dontRotate) => {
  if (Array.isArray(title_values)) {
    return dontRotate ? (
      <div>
        {title_values.map((val) => (
          <div style={{ minWidth: "max-content" }}>{`${val}`}</div>
        ))}
      </div>
    ) : (
      <div style={{ top: "50%", position: "absolute", transform: "translate(-50%, -50%)", left: "50%", width: "200px" }}>
        {title_values.map((val) => (
          <div style={{ minWidth: "max-content" }}>{`${val}`}</div>
        ))}
      </div>
    );
  }

  return title_values;
};

export const TNW_SwitchInspectionReportSchemaV1 = {
  sections: [
    {
      heights: {
        header1: "50px",
        header2: "200px",
      },
      minDataRowsCount: 5,
      columns: [
        {
          title: "MP/YARD",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "milepost",
        },
        {
          title: "SW. ID.",
          colSpan: 3,

          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "switchName",
        },

        {
          title: "MAXIMUM PTLF GAUGE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch1", "summary.pinch1"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: ["HEIGHT OF SWITCH POINT", "ABOVE STOCK RAIL"],
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate-multiline",
          titleFormatter: MultiRowTitleFormatter,
          accessor: ["summary.inch2", "summary.pinch2"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "TRACK SURFACE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch3", "summary.pinch3"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "ALIGNMENT",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch4", "summary.pinch4"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "GUARD CHECK GAUGE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch5", "summary.pinch5"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "GUARD FACE GAUGE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch6", "summary.pinch6"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "RAISED GUARD WEAR",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch9", "summary.pinch9"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        {
          title: "BRACE PLATES SECURED",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.bplate",
          dataFontSize: "12px",
        },

        {
          title: "ALL JOINT BOLTS TIGHT",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.ajointbolt",
          dataFontSize: "12px",
        },

        {
          title: "SWITCH STAND SECURE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.standSec",
          dataFontSize: "12px",
        },
        {
          title: "CONNECTING ROD SECURE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.conRodSec",
          dataFontSize: "12px",
        },
        {
          title: "MISSING COTTER PINS",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.miscot",
          dataFontSize: "12px",
        },
        {
          title: "FOOT LATCHES OPERABLE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.fotlat",
          dataFontSize: "12px",
        },
        {
          title: "SWITCH TARGET VISIBLE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.sTargVis",
          dataFontSize: "12px",
        },

        {
          title: "RAIL SIZE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "summary.rsize",
          accessor: ["attributes.Rail Size", "summary.rsize"],
          dontJoinValues: true,
          formatter: AttributeVsFormParam,
        },

        {
          title: "FROG",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "FROG #",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Frog Number", "summary.frogno"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },
            {
              title: "TYPE",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Frog Type", "summary.ftype"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },
          ],
        },
        {
          title: "SW PT",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "TYPE",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: "summary.swpty",
              accessor: ["attributes.Switch Point Type", "summary.swpty"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },
            {
              title: "LENGTH (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Switch Point Length", "summary.swptlen"],
              formatter: (val) => (getValidInchVal(val) ? val : ""),
            },
          ],
        },

        // 34. Add switch point length
        // {
        //   title: "SWITCH POINT LENGTH",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",

        //   accessor: ["attributes.Switch Point Length"],
        //   dontJoinValues: true,
        //   formatter: AttributeVsFormParam,
        // },
      ],
    },
    {
      heights: {
        header1: "60px",
      },
      minDataRowsCount: 5,
      columns: [
        {
          title: "",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-rotate",
          accessor: "milepost",
        },
        {
          title: "SW. ID.",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "switchName",
        },
       
     
      

       
        {
          title: "COMMENTS",
          colSpan: 19,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.comm",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/TNW/SwitchInspectionReport/TNW_SwitchInspectionReportSchemaV1.js